"use client"
import { useState } from "react"
import Logo from "../../assets/im1.png"
import "./navbar.css";

import { Menu } from "lucide-react"
import { SignupModal } from "./signup-modal"
import { LoginModal } from "./login-modal"
import { Button } from "../../components/ui/button"
import { cn } from "../../lib/utils"

export function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [showSignupModal, setShowSignupModal] = useState(false)
  const [showLoginModal, setShowLoginModal] = useState(false)

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen)

  const handleSignupClick = () => {
    setShowSignupModal(true)
    setShowLoginModal(false)
  }

  const handleLoginClick = () => {
    setShowLoginModal(true)
    setShowSignupModal(false)
  }

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId)
    if (element) element.scrollIntoView({ behavior: "smooth" })
    setIsMenuOpen(false)
  }

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    setIsMenuOpen(false)
  }

  return (
    <>
      <nav className="fixed top-2 left-0 w-full z-50 bg-white/80 backdrop-blur-md px-10 py-0 flex items-center justify-between">
        {/* Logo */}
        <button onClick={scrollToTop} className="flex items-center">
          <img src={Logo} alt="Logo" className="h-20 w-auto object-contain" />

        </button>

        {/* Mobile menu button */}
        <div className="md:hidden">
          <Button variant="ghost" size="icon" onClick={toggleMenu}>
            <Menu className="h-6 w-6 text-black" />
          </Button>
        </div>

        {/* Desktop navigation */}
        <div className="hidden md:flex items-center space-x-8">
          <NavLinks
            onLoginClick={handleLoginClick}
            onSignupClick={handleSignupClick}
            scrollToSection={scrollToSection}
            scrollToTop={scrollToTop}
          />
        </div>

        {/* Mobile navigation */}
        <div
          className={cn(
            "absolute top-full left-0 right-0 bg-white shadow-md md:hidden transition-all duration-300",
            isMenuOpen ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2 pointer-events-none"
          )}
        >
          {isMenuOpen && (
            <div className="flex flex-col p-6 space-y-4">
              <NavLinks
                onLoginClick={handleLoginClick}
                onSignupClick={handleSignupClick}
                scrollToSection={scrollToSection}
                scrollToTop={scrollToTop}
              />
            </div>
          )}
        </div>
      </nav>

      <SignupModal
        isOpen={showSignupModal}
        onClose={() => setShowSignupModal(false)}
        onLoginClick={() => {
          setShowSignupModal(false)
          setShowLoginModal(true)
        }}
      />

      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        onSignupClick={() => {
          setShowLoginModal(false)
          setShowSignupModal(true)
        }}
      />
    </>
  )
}

function NavLinks({ onLoginClick, onSignupClick, scrollToSection, scrollToTop }) {
  return (
    <>
      <button onClick={scrollToTop} className="nav-item">Accueil</button>
      <button onClick={() => scrollToSection("about")} className="nav-item">À propos</button>
      <button onClick={() => scrollToSection("contact")} className="nav-item">Contact</button>
      <button onClick={onLoginClick} className="nav-item">Se connecter</button>
      <button onClick={onSignupClick} className="nav-item signup-text">S&apos;inscrire</button>
    </>
  )
}
